import React from "react";
import TabMarket from "../../components/StarShowcase/Market/TabMarket";
import "./Shipping.css";

const MarketPlace = () => {
  return (
    <React.Fragment>
      <TabMarket />
    </React.Fragment>
  );
};

export default MarketPlace;
